export default {
    calamp_info_title: "Calamp",
    esn: "ESN",
    firmwareVersion: "Firmware Version",
    group: "Group",
    configGroup: "Config Group",
    mobileIdType: "Mobile Id Type",
    modemSelections: "Modem Selections",
    ipAddress: "Ip Address",
    mobileId: "Mobile Id",
    mobileId: "Mobile Id",
    imei: "IMEI",
    imsi: "IMSI",
    min: "Min",
    vehicleClass: "Vehicle Class",
    scriptVersion: "Script Version",
    configVersion: "Config Version",
    unitStatusBit1: "Unit Status Bit 1",
    unitStatusBit2: "Unit Status Bit 2",
    unitStatusBit3: "Unit Status Bit 3",
    unitStatusBit4: "Unit Status Bit 4",
    unitStatusBit5: "Unit Status Bit 5",
    unitStatusBit6: "Unit Status Bit 6",
    unitStatusBit7: "Unit Status Bit 7",
    unitStatusBit8: "Unit Status Bit 8",
    configFailReasonId: "Config Fail Reason Id",
    configStatus: "Config Status",
    firmwareStatus: "Firmware Status",
    imeiHex: "IMEI Hex",
    appId: "App Id",
    customerName: "Customer Name",
    empty: "Empty",
    version: "Version",
    configVer: "Config Version",
    scriptVer: "Script Version",
    iccId: "ICC Id",
    queryId: "Query Id",
    bitmap: "Bitmap",
    unitStatus1: "Unit Status 1",
    gpsantennaStatusOK: "Gps Antenna Status OK",
    gpsreceiverTestOK: "Gps Receiver Test OK",
    gpstrackingOK: "Gps Tracking OK",
    modemMinTestOK: "Modem Min Test OK",
    gpsexceptionReported: "GPS Exception Reported",
    bit8Ok: "Bit 8 Ok",
    bit6Ok: "Bit 6 Ok",
    trackingNum: "Tracking Number",
    customerPO: "Customer PO",
    freightCost: "Freight Cost",
    shippedDate: "Shipped Date",
    unitPartNumber: "Unit Part Number",
    boardPartNumber: "Board Part Number",
    manufactureDate: "Manufacture Date",
    versionNumber: "Version Number",
    downloadFailure: "Download Failure",
    downloadRetryCount: "Download Retry Count",
    downloadRequestTime: "Download Request Time",
    lastUpdateTime: "Last Update Time",
    firstIdReportTime: "First Id Report Time",
    lastIdReportTime: "Last Id Report Time",
    go_to_puls: "Go to PULS",

    //new
    idReport: "Id Report",
    vinValid: "Vin Valid",
    extension: "Extension",
    otaId: "Ota Id",
    vbusIdReport: "Vbus Id Report",
    statCode: "Stat Code",
    haidReport: "Haid Report",
    diagCode: "Diag Code",
    vinInfoStatus: "Vin Info Status",
    diagString: "Diag String",
    vbusDiag: "Vbus Diag",
    Imei: "IMEI",
    typeId: "Type Id",
    customId: "Custom Id",
    statusCode: "Status Code",
    infoListString: "Info List String",
    rawFileTable: "Raw File Table",
    serviceConfigVersion: "Service Config Version",
    custList: "Cust Code",
    lastConfigUpdateTime: "Las Config Update Time",
    extentionPrefix: "Extention Prefix",
    lastConfigSyncTime: "Last Config Sync Time",
    meid2: "Meid 2",
    mcc: "MCC",
    Vin: "VIN",
    linuxFileReport: "Linux File Report",
    mnc: "MNC",
    cellRadioIdReport: "Cell Radio Id Report",
    mbnName: "Mbn Name",

    deviceConfiguration: "Device Configuration",
    href: "Href",
    features: "Features",
    lastKnownGoodAvlPosition: "Last Known Good Avl Position",
    serviceProfile: "Service Profile",
    lastModifiedCarrierStatus: "Last Modified Carrier Status",
    shipDate: "Ship Date",
    status: "Status",
    lastModifiedOn: "Last Modified On",
    smsConfiguration: "SMS Configuration",
    title: "Title",
    manufacturing: "Manufacturing",
    splitTagMessages: "Split Tag Messages",
    dmDevice: "DM Device",
    groups: "Groups",
    mdn: "MDN",
    type: "Type",
    extensions: "Extensions",
    icnEnabled: "ICN Enabled",
    meid: "MEID",
    activationDate: "Activation Date",
    externalId: "External Id",
    activeAirtimePlan: "Active Airtime Plan",
    urlAvailable: "Url Available",
    Imei: "IMEI",
    airId: "Air Id",
    rel: "Rel",
    ioProfile: "IO Profile",
    provisionStatus: "Provision Status",
    category: "Category",
    replacedDevice: "Replaced Device", 
    isdn: "ISDN",
    schedules: "Schedules",
    deletionDate: "Deletion Date",
    lastAvlCommunication: "Last Avl Communication",
    lastIdReport: "Last Id Report",
    account: "Account",
    useAirtimePlan: "Use Airtime Plan",
    architecture: "Architecture",
    userDefinedMobileId: "User Defined Mobile Id",
    asset: "Asset",
    port: "Port",
    pegBehavior: "Peg Behavior",
    calamp_info_url: "Go to Calamp",
    calamp_formatted: "Formatted",
    calamp_unformatted: "JSON format",
    message: "Message",
    calamp_info: "Info",
    calamp_files: "Files",
    calamp_files_file_type: "File Type",
    calamp_files_last_update: "Last Update",
    calamp_files_new_version: "New Version",
    calamp_files_status: "Status",
    calamp_files_current: "Current",
    calamp_files_log: "Log",
    calamp_puls_customer_missing: "PulsCustomerId was not found"
}